import React from 'react';
import DashboardIcon from './icons/DashboardIcon';

export function FormIconActions({
  onSave,
  onCancel,
  className = '',
  centered = false,
}) {
  return (
    <div
      className={[
        'row-actions',
        'form-icon-actions',
        centered ? 'form-icon-actions--center' : '',
        className,
      ].filter(Boolean).join(' ')}
    >
      <button
        type="button"
        className="row-action-btn row-action-btn--confirm"
        aria-label="save"
        title="Save"
        onClick={onSave}
      >
        <DashboardIcon name="check" size={14} strokeWidth="2" />
      </button>
      <button
        type="button"
        className="row-action-btn row-action-btn--danger"
        aria-label="close"
        title="Cancel"
        onClick={onCancel}
      >
        <DashboardIcon name="close" size={14} strokeWidth="2" />
      </button>
    </div>
  );
}

export default FormIconActions;
